import React, { FC } from 'react'
import { AchievementsHook } from '../../../../hooks/useAchievements'
import { BadgeHook } from '../../../../hooks/useBadges'
import { ScoreboardHook } from '../../../../hooks/useScoreboard'
import { TimePeriodData } from '../../../../types/timePeriodData'
import ScoreboardGrid from './ScoreboardGrid'

interface ScoreboardSwiperProps {
	timePeriods: TimePeriodData[]
	data: ScoreboardHook
	achievementsHook: AchievementsHook
	badgeHook: BadgeHook
}

const ScoreboardSwiper: FC<ScoreboardSwiperProps> = ({
	timePeriods,
	data,
	achievementsHook,
	badgeHook,
}) => {
	return (
		<div className='scoreboard-swiper relative overflow-hidden cursor-grab active:cursor-grabbing'>
			<div className='swiper-wrapper'>
				{timePeriods.map((period, index) => (
					<div key={period.id} className='swiper-slide'>
						<ScoreboardGrid
							periodIndex={index}
							timePeriods={timePeriods}
							data={data}
							achievementsHook={achievementsHook}
							badgeHook={badgeHook}
						/>
					</div>
				))}
			</div>
		</div>
	)
}

export default ScoreboardSwiper
